import { getData } from "@/components/report/service";
import { convBoundFilter, convFilters } from "@/utils/query";
import moment from "moment";
import { getToDay } from '@/utils/date';
import { crudRequest } from "@/services/api";

const dataRange = getToDay()

const params = {
    startDate: dataRange[0].format('YYYY-MM-DD 12:00:00'),
    endDate: dataRange[1].format('YYYY-MM-DD 12:00:00'),
    // currentSystemTime: [
    //     moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    //     moment(new Date()).add(1, 'd').format("YYYY-MM-DD HH:mm:ss")
    // ];
    currentSystemStartTime: '', // moment(new Date()).add(-7, 'd').format("YYYY-MM-DD HH:mm:ss"),
    currentSystemEndTime: '', // moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    centerFilter: '',
    province: '',
    notNextpProv: [],
    // centerFilter: { name: "成都分拨中心", code: "5712000" },
    // province: { name: "西南经营本部", code: "0212000" },

    // startDate: '',
    // endDate: '',
    // province: '',
    // centerFilter: '',

}

export default {
    namespace: 'ProvincePlan',

    state: {
        searchParams: { ...params },
        seachStatus: false,

        // 明细弹窗
        leftTableDataList: { title: '', data: [] },
        rightTableDataList: { title: '', data: [] },
        detailModalShow: false,
    },

    effects: {
        *getDetail({ payload }, { put, select }) {
            crudRequest('/api/route/provincePlan/search_detail')   // 日志

            const { rowData, filters } = payload
            yield put({ type: 'updateState', payload: { detailModalShow: true } })
            const { searchParams: { centerFilter, startDate, endDate,
                currentSystemStartTime, currentSystemEndTime } } = yield select(({ ProvincePlan }) => ProvincePlan)

            async function fetchData(dataSource, filter) {
                let boundFilter = []
                if (currentSystemStartTime && currentSystemEndTime) {
                    boundFilter = convBoundFilter(
                        filter.boundFilters,
                        moment(currentSystemStartTime).format("YYYY-MM-DD HH:mm:ss"),
                        moment(currentSystemEndTime).format("YYYY-MM-DD HH:mm:ss")
                    )
                }

                const query = {
                    dataSource,
                    simpleGranularity: 'all',
                    startDate,
                    endDate,
                    ...filter,
                    andFilters: convFilters(filter.andFilters, centerFilter, rowData.nextSite, rowData.trackLine),
                    inFilters: [],
                    boundFilters: boundFilter
                };
                return getData(query);
            }

            let data = yield fetchData('actual_load_unload_result', filters.actual)
            yield put({ type: 'updateState', payload: { leftTableDataList: { title: '实际', data: data || [] } } })
            data = yield fetchData('route_plan_result', filters.plan)
            yield put({ type: 'updateState', payload: { rightTableDataList: { title: '预计', data: data || [] } } })
        },


        *getStock({ payload }, { put, select }) {
            crudRequest('/api/route/provincePlan/search_StockDetail')   // 日志

            const { rowData, filters } = payload
            yield put({ type: 'updateState', payload: { detailModalShow: true } })
            const { searchParams: { centerFilter, startDate, endDate,
                currentSystemStartTime, currentSystemEndTime } } = yield select(({ ProvincePlan }) => ProvincePlan)

            async function fetchData(dataSource, filter) {
                const boundFilter = []
                let temp = null
                for (let i = 0; i < filter.boundFilters.length; i++) {
                    const boundItem = filter.boundFilters[i];
                    if (boundItem.dimension === 'currentSystemTime') {
                        if (currentSystemStartTime && currentSystemEndTime) {
                            temp = convBoundFilter(
                                [boundItem],
                                moment(currentSystemStartTime).format("YYYY-MM-DD HH:mm:ss"),
                                moment(currentSystemEndTime).format("YYYY-MM-DD HH:mm:ss")
                            )
                            boundFilter.push(...temp)
                        }
                    } else if (boundItem.dimension === 'unloadAggregateTime') {
                        temp = convBoundFilter(
                            [boundItem],
                            moment(startDate).format("YYYY-MM-DD"),
                            moment(endDate).format("YYYY-MM-DD")
                        )
                        boundFilter.push(...temp)
                    } else {
                        temp = convBoundFilter(
                            [boundItem],
                            moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
                            moment(endDate).format("YYYY-MM-DD HH:mm:ss")
                        )
                        boundFilter.push(...temp)
                    }
                }

                const query = {
                    dataSource: dataSource,
                    simpleGranularity: 'all',
                    startDate,
                    endDate,
                    ...filter,
                    andFilters: convFilters(filter.andFilters, centerFilter, rowData.nextSite, rowData.trackLine),
                    inFilters: [],
                    boundFilters: boundFilter
                };
                return getData(query);
            }

            let data = yield fetchData('actual_load_unload_result', filters[1])
            yield put({ type: 'updateState', payload: { leftTableDataList: { title: '装车', data: data || [] } } })
            data = yield fetchData('actual_load_unload_result', filters[0])
            yield put({ type: 'updateState', payload: { rightTableDataList: { title: '卸车', data: data || [] } } })
        },
    },

    reducers: {
        updateState(state, { payload }) {
            return { ...state, ...payload };
        },
        updateSearchParams(state, { payload }) {
            return { ...state, searchParams: { ...state.searchParams, ...payload } };
        },
        resetSearchParam(state) {
            return { ...state, searchParams: { ...params } };
        },
    }
}
